import { useDataBoxSelector } from 'app/common/data-box-store'
import { RecipientsInfo } from 'app/dataTypes/transfer/recipients'

import { recipientsInfo } from '../dataBox'


export function useRecipientsInfoData() {
  const data = useDataBoxSelector<RecipientsInfo>(recipientsInfo, () => recipientsInfo.data)
  return data
}
